import React from 'react';
import PropTypes from 'prop-types';

function ExternalLinkButton({
  caption,
  className,
  textColor,
  bgColor,
  fontSize,
  fontWeight,
  border,
  borderColor,
  padding,
  lineHeight,
  href,
  id
}) {
  return (
    <div className={className}>
      <a
        id={id}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        style={{ fontSize: fontSize, padding: padding, lineHeight: lineHeight }}
        className={`rounded cursor-pointer ${textColor} ${bgColor} ${fontWeight} ${border} ${borderColor}`}
      >
        {caption}
      </a>
    </div>
  );
}
export default ExternalLinkButton;

ExternalLinkButton.propTypes = {
  caption: PropTypes.string,
  className: PropTypes.string,
  textColor: PropTypes.string,
  bgColor: PropTypes.string,
  onClick: PropTypes.func,
  fontSize: PropTypes.string,
  bgColor: PropTypes.string,
  fontWeight: PropTypes.string,
  border: PropTypes.string,
  fontWeight: PropTypes.string,
  borderColor: PropTypes.string,
  padding: PropTypes.string
};

ExternalLinkButton.defaultProps = {
  padding: '11px 32px',
  textColor: 'text-white',
  fontSize: '12px',
  bgColor: 'bg-orange-500',
  lineHeight: '12px'
};
